module.exports = __webpack_public_path__ + "img/sidebar_img.79427fe9.jpg";